import { $, show, hide } from './utils.js';

interface EmojiCategory {
  label: string;
  emojis: { code: string; char: string }[];
}

const EMOJI_CATEGORIES: EmojiCategory[] = [
  {
    label: 'Smileys',
    emojis: [
      { code: 'happy', char: '😀' },
      { code: 'smile', char: '😊' },
      { code: 'laugh', char: '😂' },
      { code: 'lol', char: '🤣' },
      { code: 'wink', char: '😉' },
      { code: 'heart_eyes', char: '😍' },
      { code: 'cool', char: '😎' },
      { code: 'thinking', char: '🤔' },
      { code: 'confused', char: '😕' },
      { code: 'sad', char: '😢' },
      { code: 'cry', char: '😭' },
      { code: 'angry', char: '😠' },
      { code: 'rage', char: '🤬' },
      { code: 'scream', char: '😱' },
      { code: 'skull', char: '💀' },
      { code: 'clown', char: '🤡' },
      { code: 'ghost', char: '👻' },
      { code: 'sleeping', char: '😴' },
      { code: 'sick', char: '🤢' },
      { code: 'nerd', char: '🤓' },
      { code: 'shush', char: '🤫' },
      { code: 'eye_roll', char: '🙄' },
      { code: 'smirk', char: '😏' },
      { code: 'yawn', char: '🥱' },
      { code: 'tongue', char: '😛' },
      { code: 'surprise', char: '😮' },
      { code: 'worried', char: '😟' },
      { code: 'flushed', char: '😳' },
      { code: 'pleading', char: '🥺' },
      { code: 'bruh', char: '😐' },
      { code: 'sus', char: '🤨' },
    ],
  },
  {
    label: 'Gestures',
    emojis: [
      { code: 'thumbsup', char: '👍' },
      { code: 'thumbsdown', char: '👎' },
      { code: 'wave', char: '👋' },
      { code: 'clap', char: '👏' },
      { code: 'pray', char: '🙏' },
      { code: 'muscle', char: '💪' },
      { code: 'fist', char: '✊' },
      { code: 'point_up', char: '☝️' },
      { code: 'ok_hand', char: '👌' },
      { code: 'peace', char: '✌️' },
      { code: 'shrug', char: '🤷' },
      { code: 'facepalm', char: '🤦' },
      { code: 'salute', char: '🫡' },
      { code: 'eyes', char: '👀' },
      { code: 'brain', char: '🧠' },
    ],
  },
  {
    label: 'Hearts',
    emojis: [
      { code: 'heart', char: '❤️' },
      { code: 'orange_heart', char: '🧡' },
      { code: 'yellow_heart', char: '💛' },
      { code: 'green_heart', char: '💚' },
      { code: 'blue_heart', char: '💙' },
      { code: 'purple_heart', char: '💜' },
      { code: 'broken_heart', char: '💔' },
      { code: 'sparkling_heart', char: '💖' },
      { code: 'fire_heart', char: '❤️‍🔥' },
      { code: 'kiss', char: '💋' },
    ],
  },
  {
    label: 'Celebrate',
    emojis: [
      { code: 'party', char: '🥳' },
      { code: 'tada', char: '🎉' },
      { code: 'confetti', char: '🎊' },
      { code: 'trophy', char: '🏆' },
      { code: 'medal', char: '🥇' },
      { code: 'crown', char: '👑' },
      { code: 'star', char: '⭐' },
      { code: 'sparkles', char: '✨' },
      { code: 'balloon', char: '🎈' },
      { code: 'gift', char: '🎁' },
      { code: 'gg', char: '🏆' },
      { code: 'w', char: '🏅' },
    ],
  },
  {
    label: 'Objects',
    emojis: [
      { code: 'fire', char: '🔥' },
      { code: '100', char: '💯' },
      { code: 'money', char: '💰' },
      { code: 'dollar', char: '💵' },
      { code: 'cash', char: '💸' },
      { code: 'gem', char: '💎' },
      { code: 'bell', char: '🔔' },
      { code: 'megaphone', char: '📢' },
      { code: 'bomb', char: '💣' },
      { code: 'lightning', char: '⚡' },
      { code: 'snowflake', char: '❄️' },
      { code: 'sun', char: '☀️' },
      { code: 'moon', char: '🌙' },
      { code: 'rainbow', char: '🌈' },
      { code: 'rocket', char: '🚀' },
      { code: 'dice', char: '🎲' },
      { code: 'controller', char: '🎮' },
      { code: 'music', char: '🎵' },
      { code: 'check', char: '✅' },
      { code: 'x', char: '❌' },
      { code: 'warning', char: '⚠️' },
      { code: 'no', char: '🚫' },
      { code: 'question', char: '❓' },
    ],
  },
  {
    label: 'Monopoly',
    emojis: [
      { code: 'tophat', char: '🎩' },
      { code: 'bank', char: '🏦' },
      { code: 'hotel', char: '🏨' },
      { code: 'house', char: '🏠' },
      { code: 'train', char: '🚂' },
      { code: 'railroad', char: '🚃' },
      { code: 'jail', char: '🔒' },
      { code: 'key', char: '🔑' },
      { code: 'handshake', char: '🤝' },
      { code: 'chart', char: '📈' },
      { code: 'cap', char: '🧢' },
      { code: 'rip', char: '🪦' },
    ],
  },
  {
    label: 'Animals',
    emojis: [
      { code: 'dog', char: '🐶' },
      { code: 'cat', char: '🐱' },
      { code: 'bear', char: '🐻' },
      { code: 'monkey', char: '🐵' },
      { code: 'pig', char: '🐷' },
      { code: 'chicken', char: '🐔' },
      { code: 'frog', char: '🐸' },
      { code: 'unicorn', char: '🦄' },
      { code: 'dragon', char: '🐉' },
      { code: 'snake', char: '🐍' },
      { code: 'penguin', char: '🐧' },
      { code: 'butterfly', char: '🦋' },
      { code: 'bee', char: '🐝' },
    ],
  },
  {
    label: 'Food',
    emojis: [
      { code: 'pizza', char: '🍕' },
      { code: 'burger', char: '🍔' },
      { code: 'taco', char: '🌮' },
      { code: 'cookie', char: '🍪' },
      { code: 'cake', char: '🎂' },
      { code: 'ice_cream', char: '🍦' },
      { code: 'donut', char: '🍩' },
      { code: 'apple', char: '🍎' },
      { code: 'watermelon', char: '🍉' },
      { code: 'coffee', char: '☕' },
      { code: 'juice', char: '🧃' },
    ],
  },
];

// Build flat lookup map from categories
const EMOJI_MAP: Record<string, string> = {};
for (const cat of EMOJI_CATEGORIES) {
  for (const e of cat.emojis) {
    EMOJI_MAP[e.code] = e.char;
  }
}
// Extra aliases not shown in picker
EMOJI_MAP['blush'] = '😊';
EMOJI_MAP['moneybag'] = '💰';
EMOJI_MAP['free'] = '🆓';
EMOJI_MAP['nocap'] = '🚫🧢';
EMOJI_MAP['l'] = '😔';
EMOJI_MAP['oof'] = '💀';
EMOJI_MAP['ez'] = '😎';
EMOJI_MAP['pin'] = '📌';
EMOJI_MAP['lock'] = '🔒';
EMOJI_MAP['umbrella'] = '☂️';
EMOJI_MAP['airplane'] = '✈️';
EMOJI_MAP['car'] = '🚗';
EMOJI_MAP['joystick'] = '🕹️';
EMOJI_MAP['microphone'] = '🎤';

function replaceEmojis(text: string): string {
  return text.replace(/:([a-zA-Z0-9_]+):/g, (match, code) => {
    return EMOJI_MAP[code.toLowerCase()] || match;
  });
}

function buildEmojiPicker(picker: HTMLElement, input: HTMLInputElement): void {
  for (const cat of EMOJI_CATEGORIES) {
    const heading = document.createElement('div');
    heading.className = 'emoji-cat-label';
    heading.textContent = cat.label;
    picker.appendChild(heading);

    const grid = document.createElement('div');
    grid.className = 'emoji-grid';

    for (const e of cat.emojis) {
      const btn = document.createElement('button');
      btn.className = 'emoji-btn';
      btn.textContent = e.char;
      btn.title = `:${e.code}:`;
      btn.type = 'button';
      btn.addEventListener('click', () => {
        const start = input.selectionStart ?? input.value.length;
        const end = input.selectionEnd ?? start;
        const before = input.value.slice(0, start);
        const after = input.value.slice(end);
        input.value = before + e.char + after;
        const cursor = start + e.char.length;
        input.setSelectionRange(cursor, cursor);
        input.focus();
      });
      grid.appendChild(btn);
    }

    picker.appendChild(grid);
  }
}

export function initChatUI(socket: any): void {
  const input = $('#chat-input') as HTMLInputElement;
  const sendBtn = $('#chat-send') as HTMLButtonElement;
  const messages = $('#chat-messages');
  const emojiToggle = $('#emoji-toggle') as HTMLButtonElement;
  const emojiPicker = $('#emoji-picker');

  buildEmojiPicker(emojiPicker, input);

  emojiToggle.addEventListener('click', () => {
    if (emojiPicker.classList.contains('hidden')) {
      show(emojiPicker);
    } else {
      hide(emojiPicker);
    }
  });

  // Close picker when clicking outside
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (!emojiPicker.contains(target) && target !== emojiToggle) {
      hide(emojiPicker);
    }
  });

  function sendMessage(): void {
    const text = input.value.trim();
    if (!text) return;
    socket.emit('chat:message', text);
    input.value = '';
    hide(emojiPicker);
  }

  sendBtn.addEventListener('click', sendMessage);
  input.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Enter') sendMessage();
  });

  const MAX_CHAT_MESSAGES = 100;
  socket.on('chat:message', (data: { playerName: string; text: string }) => {
    const entry = document.createElement('div');
    entry.className = 'chat-msg';

    const name = document.createElement('span');
    name.className = 'chat-name';
    name.textContent = data.playerName + ': ';

    const text = document.createElement('span');
    text.textContent = replaceEmojis(data.text);

    entry.appendChild(name);
    entry.appendChild(text);
    messages.appendChild(entry);
    // Cap history — unbounded chat DOM was making every render's layout
    // slower as the game progressed.
    while (messages.children.length > MAX_CHAT_MESSAGES) {
      messages.removeChild(messages.firstChild!);
    }
    messages.scrollTop = messages.scrollHeight;
  });
}
